import { filter } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';

export class IEvent {
  name: string;
  value: any[];
}

export class EventBus {

  protected bus: Subject<IEvent> = new Subject<IEvent>();

  public emit(eventName: string, ...args: any[]): void {
    this.bus.next(<IEvent>{
      name: eventName,
      value: args
    });
  }

  public on(eventName: string): Observable<any> {
    return this.bus.asObservable().pipe(
      filter((event: IEvent) => event.name === eventName));
  }

  public release(): void {
    this.bus.unsubscribe();
    this.bus = new Subject<IEvent>();
  }
}
